const formatDate = (lang, date) => {
  const data = new Date(date);
  const userLang = lang || navigator.language;
  let month = data.toLocaleString(userLang, { month: 'long' });
  return data.getDate() + ' ' + month + ' ' + data.getFullYear();
};

export const formatIds = (field) => {
  const fields = field.split('.');
  return fields[fields.length - 1];
};

export default { formatDate };
